webpackJsonp([19227479773323],{

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(11);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Message = __webpack_require__(138);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _Loader = __webpack_require__(137);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//Message Box
	
	
	//Loader
	
	
	var SuggestionsForm = function (_Component) {
	  _inherits(SuggestionsForm, _Component);
	
	  function SuggestionsForm(props) {
	    _classCallCheck(this, SuggestionsForm);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleChange = function (event) {
	      var state = _this.state.data;
	      state[event.target.name] = event.target.value;
	      _this.setState(state);
	    };
	
	    _this.handleHighlightEmptyValues = function (value) {
	      if (_this.state.emptyValues && _.isEmpty(value)) {
	        return 'inputNormal inputError';
	      }
	      return 'inputNormal';
	    };
	
	    _this.handleSubmit = function (event) {
	      event.preventDefault();
	
	      if (_this.hasEmptyValue()) {
	        _this.setState({
	          emptyValues: true,
	          resText: 'There are errors in the form. Please correct them and resubmit the form.'
	        });
	      } else {
	        _this.setState({ emptyValues: false, loading: true });
	        (0, _axios2.default)({
	          method: 'post',
	          data: _this.state.data,
	          url: 'https://bkndNicaragua.miweb.cr:5004/api/contactForms/add'
	        }).then(function (res) {
	          console.log(res);
	          _this.setState({
	            loading: false,
	            sent: true,
	            resText: 'Thank you. Your information has been sent'
	          });
	        }).catch(function (err) {
	          _this.setState({
	            loading: false,
	            error: true,
	            resText: 'Sorry we could not send your information. Please try later'
	          });
	          console.log(err);
	        });
	      }
	    };
	
	    _this.state = {
	      nofication: null,
	      showNotification: false,
	      data: {
	        type: 'Suggestions',
	        title: 'Suggestions',
	        firstname: '',
	        lastname: '',
	        phone: '',
	        email: '',
	        message: ''
	      },
	      loading: false,
	      formIsValid: false,
	      resText: '',
	      sent: false,
	      error: false,
	      language: {
	        la: 'es',
	        firstname: 'First name:',
	        lastname: 'Last name:',
	        phone: 'Phone:',
	        email: 'E-mail:',
	        suggestion: 'Suggestion:',
	        button: 'Send',
	        notificationErr: 'The suggestion could not be sent. Please try later.',
	        noficationSend: 'Thanks your suggestion has been sent.',
	        sending: 'Sending...'
	      }
	    };
	    _this.handleHighlightEmptyValues = _this.handleHighlightEmptyValues.bind(_this);
	    return _this;
	  }
	
	  SuggestionsForm.prototype.hasEmptyValue = function hasEmptyValue() {
	    var _state$data = this.state.data,
	        type = _state$data.type,
	        firstname = _state$data.firstname,
	        lastname = _state$data.lastname,
	        phone = _state$data.phone,
	        email = _state$data.email,
	        message = _state$data.message;
	
	    var emptyValues = _.some([type, firstname, lastname, phone, email, message], function (value) {
	      return value === '';
	    });
	    if (emptyValues) {
	      return true;
	    }
	    return false;
	  };
	
	  SuggestionsForm.prototype.render = function render() {
	    if (this.props.lan === 'es') {
	      this.state.language = {
	        la: 'es',
	        firstname: 'Nombre:',
	        lastname: 'Apellidos:',
	        phone: 'Teléfono:',
	        email: 'E-mail:',
	        suggestion: 'Sugerencia:',
	        button: 'Enviar',
	        notificationErr: 'La sugerencia no pudo ser enviada. Por favor intente mas tarde.',
	        noficationSend: 'Gracias, tu sugerencia ha sido enviada.',
	        sending: 'Enviado...'
	      };
	    }
	
	    var respondField = null;
	
	    if (this.state.loading) {
	      respondField = _react2.default.createElement(_Loader2.default, null);
	    }
	    if (this.state.sent || this.state.error || this.state.emptyValues) {
	      respondField = _react2.default.createElement(_Message2.default, { text: this.state.resText });
	    }
	
	    return _react2.default.createElement(
	      'form',
	      { className: 'ContactFrom', onSubmit: this.handleSubmit },
	      _react2.default.createElement(
	        'div',
	        { className: 'firstBlock' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'firstname' },
	            this.state.language.firstname
	          ),
	          _react2.default.createElement('input', {
	            type: 'text',
	            name: 'firstname',
	            onChange: this.handleChange,
	            className: this.handleHighlightEmptyValues(this.state.firstname)
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'lastname' },
	            this.state.language.lastname
	          ),
	          _react2.default.createElement('input', {
	            type: 'text',
	            name: 'lastname',
	            onChange: this.handleChange,
	            className: this.handleHighlightEmptyValues(this.state.lastname)
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'phone' },
	            this.state.language.phone
	          ),
	          _react2.default.createElement('input', {
	            type: 'text',
	            name: 'phone',
	            onChange: this.handleChange,
	            className: this.handleHighlightEmptyValues(this.state.phone)
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'email' },
	            this.state.language.email
	          ),
	          _react2.default.createElement('input', {
	            type: 'email',
	            name: 'email',
	            onChange: this.handleChange,
	            className: this.handleHighlightEmptyValues(this.state.email)
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'secondBlock' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'message' },
	            this.state.language.suggestion
	          ),
	          _react2.default.createElement('textarea', {
	            type: 'email',
	            name: 'message',
	            onChange: this.handleChange,
	            className: this.handleHighlightEmptyValues(this.state.message)
	          })
	        )
	      ),
	      respondField,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'btn' },
	          this.state.language.button
	        )
	      )
	    );
	  };
	
	  return SuggestionsForm;
	}(_react.Component);
	
	exports.default = SuggestionsForm;
	module.exports = exports['default'];

/***/ }),

/***/ 801:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SuggestionsForm = __webpack_require__(540);
	
	var _SuggestionsForm2 = _interopRequireDefault(_SuggestionsForm);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuggestionsEn = function SuggestionsEn() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'page suggestions' },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Send Us Your Suggestions | Budget Nicaragua',
	      meta: [{
	        name: 'description',
	        content: 'Frequently Asked Questions about car rentals.'
	      }],
	      link: [{
	        rel: 'alternate',
	        hreflang: 'en',
	        href: './es/suggestions'
	      }]
	    }),
	    _react2.default.createElement('div', { className: 'image' }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Suggestions'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'grid-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'block-first' },
	        _react2.default.createElement(_SuggestionsForm2.default, { lan: 'en' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'block-second' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'We want your trip with Budget Car and Truck Rental to be your best experience.'
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'mail', href: 'mailto:feedback@budget.com.ni' },
	          'feedback@budget.com.ni'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: 'tel:+50522559000' },
	          '+505 2255-9000'
	        )
	      )
	    )
	  );
	};
	exports.default = SuggestionsEn;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-suggestions-en-js-c248f44014a92414e927.js